'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { useLocale } from 'next-intl';
import { useTripId } from '~/hooks/useTripId';
import type { PlaceNames } from '~/server/trip/getPlaceNamesForTrip';
import { makePlaceNamesCmsKey } from '../overviewPage/HydratedOverview';
export const usePlaceNames = () => {
  const $ = _c(7);
  const tripId = useTripId();
  const locale = useLocale();
  let t0;
  if ($[0] !== locale || $[1] !== tripId) {
    t0 = makePlaceNamesCmsKey(tripId, locale);
    $[0] = locale;
    $[1] = tripId;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== t0) {
    t1 = {
      queryKey: t0,
      enabled: false
    };
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    data
  } = useQuery(t1);
  let t2;
  if ($[5] !== data) {
    t2 = data ?? {};
    $[5] = data;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};